import React, { useState } from 'react';
import { BookOpen, Check, Play, ShieldCheck, Sparkles, Square } from 'lucide-react';
import { Link } from 'react-router';
import { playSpeech, stopVerse } from '../services/ttsService';
import ScreenLayout from './ScreenLayout';

const sample = 'God of peace, meet me in the middle of today. Help me release what I cannot control, receive the wisdom I need, and take the next faithful step with courage. Amen.';

export default function PrayerLab() {
  const [playing, setPlaying] = useState(false);
  const [speechError, setSpeechError] = useState('');
  const speak = async () => {
    if (playing) {
      stopVerse();
      setPlaying(false);
      return;
    }
    setSpeechError('');
    setPlaying(true);
    try {
      await playSpeech({
        text: sample,
        onEnd: () => setPlaying(false),
        onError: () => {
          setPlaying(false);
          setSpeechError('The sample could not be played.');
        }
      });
    } catch (error) {
      setPlaying(false);
      setSpeechError(error.message || 'The sample could not be played.');
    }
  };
  return (
    <ScreenLayout
      title="Prayer Lab"
      icon={Sparkles}
      eyebrow="Personal prayer"
      className="detail-lab"
      actions={<Link className="module-text-control" to="/prayer">Today’s prayer</Link>}
    >
      <div className="vd-lab">
        <header className="detail-heading">
          <p className="detail-date">AI-assisted prayer</p>
          <h1>Make space for a personal prayer.</h1>
          <p className="detail-subtitle">A place for custom planning and prayer. Scripture throughout Prayer Guide stays curated and never AI-written.</p>
        </header>
        <div className="vd-lab-grid">
          <section>
            <header><ShieldCheck size={22} /><div><strong>Christian guardrails</strong><small>Prayerful, Scripture-aware, and clearly reviewable</small></div></header>
            <ul>
              <li><Check size={15} /> AI never rewrites or impersonates Scripture</li>
              <li><Check size={15} /> Generated prayers are labeled every time</li>
              <li><Check size={15} /> You review before anything is scheduled</li>
            </ul>
            <Link to="/prayer/generate">Open the custom prayer builder</Link>
          </section>
          <section className="vd-voice-lab">
            <small>Listen · sample prayer</small>
            <blockquote>“{sample}”</blockquote>
            <button className="vd-play-prayer" onClick={speak}>{playing ? <Square size={17} /> : <Play size={17} />} {playing ? 'Stop sample' : 'Hear this prayer'}</button>
            {speechError ? <p className="vd-flow-error" role="alert">{speechError}</p> : null}
          </section>
        </div>
        <p className="vd-lab-note"><BookOpen size={16} /> AI can help plan and phrase a personal prayer. It does not replace Scripture, pastoral care, or your own discernment.</p>
      </div>
    </ScreenLayout>
  );
}
